<footer
  class="min-footer-height w-full bg-primary pb-md text-secondary"
  [class.footer-margin]="!noFooterMargin"
  *transloco="let t"
>
  <div class="h-layout pt-12">
    <div class="pb-8">
      <address class="text-base not-italic">
        <ul class="inline-list-desktop-only sm:space-x-md">
          <li>
            <a [href]="t('shared.support.email') | bgoMailTo">{{ t('shared.support.email') }}</a>
          </li>
          <li class="hidden sm:block">•</li>
          <li>
            <a [href]="t('shared.support.phone') | bgoTel">{{ t('shared.support.phone') }}</a>
            ({{ t('shared.support.operatingHours') }})
          </li>
        </ul>
      </address>

      @if (showLegalLinks) {
        <nav aria-label="Legal">
          <ul class="inline-list-desktop-only mt-md list-none text-base sm:space-x-8 print:hidden">
            <li>
              <a
                class="hover:underline"
                [href]="linkService.localizedPathTo(APPLICATION_ROUTES.PRO_TERMS_AND_CONDITIONS)"
                bgoOpenNewTab
              >
                {{ t('footer.legalMenu.tcPro') }}
              </a>
            </li>
            <li>
              <a
                class="hover:underline"
                [href]="linkService.localizedPathTo(APPLICATION_ROUTES.CLIENT_TERMS_AND_CONDITIONS)"
                bgoOpenNewTab
              >
                {{ t('footer.legalMenu.tcClient') }}
              </a>
            </li>
            <li>
              <a [routerLink]="linkService.localizedPathTo(APPLICATION_ROUTES.DATA_PRIVACY)" class="hover:underline">
                {{ t('footer.legalMenu.dataProtection') }}
              </a>
            </li>
          </ul>
        </nav>
      }

      <div class="mt-xl sm:flex sm:justify-between sm:text-center print:hidden">
        <div class="text-sm">
          <fa-icon [icon]="faHeart"></fa-icon>
          {{ t('footer.madeWithLove') }}
        </div>
        <div class="text-xs text-grey-400">{{ t('footer.copyright') }}</div>
      </div>
    </div>
  </div>
</footer>
